import { FC } from 'react';

import { getRatioOfCurrentTimeInRange, getStartEndTime } from '@rikstv/play-common/src/utils/date/date.utils';
import { isOneOf } from '@rikstv/play-common/src/utils/types/typeUtils';
import { AppJumpRoundIcon, PlayRoundIcon } from '@rikstv/play-player/src/icons';
import { Accordion, SubBody } from '@rikstv/shared-components';

import { Program } from '../../../forces/channels/channel.types';
import { Link } from '../../../router/Link';
import { getImagePackSet } from '../../../utils/imagePack/imagePack.utils';
import { AssetImage } from '../../assetImage/AssetImage';
import { DurationBar } from '../../durationBar/DurationBar';
import { Breakpoints } from '../../grid/breakpoints';
import { ImageOverlayWrapper } from '../../imageOverlays/ImageOverlayWrapper';

import { TvGuideProgramNavigation } from './TvGuideProgramNavigation';
import { TvGuideProgramTitle } from './TvGuideProgramTitle';

import styles from './TvGuideProgram.module.css';

interface Props {
  program: Program;
  isCurrentProgram?: boolean;
}

export const TvGuideProgram: FC<Props> = ({ program, isCurrentProgram }) => {
  return (
    <div>
      <Accordion
        className={styles.accordion}
        heading={<TvGuideProgramTitle className={styles.title} isCurrentProgram={isCurrentProgram} program={program} />}
        initialOpen={false}>
        <div className={styles.wrapper}>
          {program.subtitle && <SubBody className={styles.description}>{program.subtitle}</SubBody>}
          <TvGuideProgramNavigation program={program} isPlayable={isOneOf(program.state, ['Default', 'Live'])}>
            <AssetImage
              rounded
              blackWhite={!isOneOf(program.state, ['Default', 'Live', 'Planned'])}
              imageSet={getImagePackSet({
                url: program.image,
                variations: [
                  { width: 600, breakpoint: Breakpoints.SM },
                  { width: 730, breakpoint: Breakpoints.XS },
                  { width: 600, breakpoint: Breakpoints.DEFAULT },
                ],
              })}
              alt={program.name}></AssetImage>
            <ImageOverlayWrapper backdropStyle={isCurrentProgram ? 'gradient' : 'none'}>
              {program.externalPlayback ? (
                <AppJumpRoundIcon iconSize={44} className={styles.playOverlay} />
              ) : (
                <PlayRoundIcon iconSize={44} className={styles.playOverlay} />
              )}
              {isCurrentProgram && (
                <DurationBar percent={getPlaytimePercentForProgram(program)} className={styles.durationBar} />
              )}
            </ImageOverlayWrapper>
          </TvGuideProgramNavigation>
          {program.description && <SubBody className={styles.description}>{program.description}</SubBody>}
          {program.coverPageUrl && <Link to={program.coverPageUrl}>Les mer</Link>}
        </div>
      </Accordion>
    </div>
  );
};
const getPlaytimePercentForProgram = (program: Program): number => {
  const { start, end } = getStartEndTime(program.time, program.duration);
  return getRatioOfCurrentTimeInRange(start, end) * 100;
};
